import './SuggestionsOverlay.css';
import '../../../core/components/app-root/AppRoot.css';
import '../../../core/styles/virtualFocus.css';
import './Suggestion.css';
import './SuggestionDetails.css';
import './RecentPinnedSuggestionItem.css';
export var recentSuggestion = '_vt0w9g0-3-12-1';
export var suggestionPin = '_vt0w9g1-3-12-1';